import { Helmet } from 'react-helmet';
import UploadchiadataDetail
  from 'src/components/uploadchiadata-detail/UploadchiadataDetail';
  import UploadListToolbar from 'src/components/uploadchiadata-detail/UploadListToolbar';
import {
  Box,
  Container,
} from '@material-ui/core';

const Uploadchiadata = () => (
  <>
    <Helmet>
      <title>Upload chia data</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
      <UploadListToolbar />
        <Box sx={{ pt: 3 }}>
          <UploadchiadataDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Uploadchiadata;
